module.exports = __webpack_public_path__ + "static/media/DoctorsBest.ccff4da3.png";